import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Gallery from 'dibs-vg/dist/react/gallery';
import copy from './requestMoreImagesCopy.json';
import style from './RequestMoreImages-style.scss';

import TradeProcurementRenderer from '../../../../global/components/TradeProcurement/TradeProcurementRenderer';

class CarouselItemRequestMoreImages extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    openModal(event) {
        event.preventDefault();
        this.setState({
            isOpen: true,
        });
    }
    closeModal() {
        this.setState({
            isOpen: false,
        });
    }
    render() {
        const { isRemoveContactDealerCTATestRunning, onContactDealerClick, itemId } = this.props;
        const requestText = isRemoveContactDealerCTATestRunning
            ? copy.provideMoreImagesText
            : copy.requestText;
        const contactDealerText = isRemoveContactDealerCTATestRunning
            ? copy.requestImages
            : copy.contactDealer;

        return (
            <div className={style.container}>
                <Gallery className={style.icon} />
                <div className={style.header}>{copy.needText}</div>
                <div className={style.subheader}>{requestText}</div>
                <a
                    className={style.link}
                    onClick={event => {
                        if (isRemoveContactDealerCTATestRunning) {
                            this.openModal(event);
                        } else {
                            onContactDealerClick({
                                isRequestMoreImages: true,
                                linkLocation: 'pdp image carousel',
                            });
                        }
                    }}
                >
                    {contactDealerText}
                </a>
                {isRemoveContactDealerCTATestRunning && (
                    <TradeProcurementRenderer
                        isOpen={this.state.isOpen}
                        closeModal={this.closeModal}
                        itemIds={[itemId]}
                        isRemoveContactDealerCTATestRunning
                    />
                )}
            </div>
        );
    }
}

CarouselItemRequestMoreImages.propTypes = {
    onContactDealerClick: PropTypes.func,
    isRemoveContactDealerCTATestRunning: PropTypes.bool,
    itemId: PropTypes.string,
};

CarouselItemRequestMoreImages.defaultProps = {
    onContactDealerClick: () => {},
};

export default CarouselItemRequestMoreImages;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Carousel/RequestMoreImages/CarouselItemRequestMoreImages.jsx